import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-streamup',
  templateUrl: './streamup.component.html',
})
export class StreamupComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
